// sass native
@use 'sass:map';

// csc-button
@use '~@cewe-designsystem-stylecomponents/button' as button;

// csc-mixins
@use '~@cewe-designsystem-stylecomponents/mixins/colors' as colors;
@use '~@cewe-designsystem-stylecomponents/mixins/breakpoints' as breakpoints;

// csc-input
@use '~@cewe-designsystem-stylecomponents/input' as input with (
  $csc-input-filled-color-bg: var(--cwc-newsletter-signup-v2-input-background-color, rgb(238, 236, 234)),
  $csc-input-color-error: #c79503,
  $csc-input-padding: 0.5rem
);
$csc-input-filled-color-bg-error: var(--cwc-newsletter-signup-v2-input-background-color-error, #fff0bf) !default;

// csc-loading-animation
@use '~@cewe-designsystem-stylecomponents/loading-animation' as loadingAnimation with (
  $csc-loading-animation-color: var(--cwc-newsletter-signup-v2-loading-animation-background-color, rgb(221, 213, 205))
);

$cwc-newsletter-signup-v2-margin: var(--cwc-newsletter-signup-v2-margin, 1.5rem) !default;
$cwc-newsletter-signup-v2-headline-margin: var(--cwc-newsletter-signup-v2-headline-margin, 0.5rem) !default;
$cwc-newsletter-signup-v2-max-width-desktop: var(--cwc-newsletter-signup-v2-max-width-desktop, 500px) !default;
$cwc-newsletter-signup-v2-input-padding: var(--cwc-newsletter-signup-v2-input-padding, 1rem) !default;
$cwc-newsletter-signup-v2-input-border-radius: var(--cwc-newsletter-signup-v2-input-border-radius, 5px) !default;
$cwc-newsletter-signup-v2-subtext-color: var(--cwc-newsletter-signup-v2-subtext-color) !default;

/* cwc-newsletter-signup */
:host {
  display: flex;
  font-family: var(--cwc-newsletter-signup-v2-font-family, var(--base-font-family));

  cwc-newsletter-signup {
    &-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
    }

    &-main {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 $cwc-newsletter-signup-v2-margin;
      text-align: center;

      @include breakpoints.breakpoint(sm, up) {
        max-width: $cwc-newsletter-signup-v2-max-width-desktop;
      }
    }

    &-headline {
      display: block;
      margin-bottom: $cwc-newsletter-signup-v2-headline-margin; //margin will collapse if *-headline is empty
    }

    &-subheadline {
      display: block;
    }

    &-text {
      display: block;
      margin: $cwc-newsletter-signup-v2-margin 0;
      text-align: center;
    }

    &-subtext {
      margin-bottom: $cwc-newsletter-signup-v2-margin; //margin will collapse if *-subtext is empty
      color: $cwc-newsletter-signup-v2-subtext-color;
      font-size: 11px;
    }
  }

  ::slotted([slot$='-illustration']) {
    width: 100%;
  }

  .btn-container {
    display: flex;
    flex-direction: column;
  }

  .csc-button {
    @include button.button;
  }

  .csc-button-basic {
    @include button.button--basic;
  }

  .csc-button-strong--on-light {
    @include button.button-strong--on-light;

    &[disabled] {
      @include button.button-strong--on-light--disabled;
    }
  }

  .csc-button-lite--on-light {
    @include button.button-lite--on-light;

    &[disabled] {
      @include button.button-lite--on-light--disabled;
    }
  }

  .csc-button-strong--on-light,
  .csc-button-lite--on-light {
    &:not(:last-child) {
      // Spacing between the buttons
      margin-bottom: $cwc-newsletter-signup-v2-margin;
    }
  }

  form {
    display: flex;
    position: relative;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    margin-top: calc($cwc-newsletter-signup-v2-margin * 2);

    input {
      @extend %csc-input;
      min-width: 275px;
      margin-top: 0;
      padding: $cwc-newsletter-signup-v2-input-padding;
      border-radius: $cwc-newsletter-signup-v2-input-border-radius $cwc-newsletter-signup-v2-input-border-radius 0 0;

      background-color: input.$csc-input-filled-color-bg;
      font-family: var(--cwc-newsletter-signup-v2-font-family, var(--base-font-family));

      &:invalid {
        margin-bottom: 0;
        background-color: $csc-input-filled-color-bg-error;
      }

      &:focus,
      &:hover {
        margin-bottom: 0;
      }
    }

    strong {
      position: absolute;
      top: calc(25px + 2 * $cwc-newsletter-signup-v2-input-padding);
      left: $cwc-newsletter-signup-v2-input-padding;
      width: calc(100% - 2 * $cwc-newsletter-signup-v2-input-padding);
      color: input.$csc-input-color-error;
      font-size: 60%;
      text-align: left;
    }
  }

  csc-loading-animation[type='small'] {
    @extend %csc-loading-animation-small;

    margin-top: 0.5rem;
    padding: $cwc-newsletter-signup-v2-margin 0;
  }
}

:host([sign-up-state='initial']),
:host([sign-up-state='load']) {
  cwc-newsletter-signup-text {
    text-align: left;
  }

  .btn-container {
    // Because we are not allowed to add a bottom margin to the input field,
    // a top margin is added to the following element (the button container).
    margin-top: calc($cwc-newsletter-signup-v2-margin * 2);
  }
}
